import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { SecurityService } from './Security.service';

@Injectable()
export class AppInitializer {
    public constructor(private securityService: SecurityService) {}

    public Init() {
        console.info('Running: ', environment.envName);

        // Clears cached JetFile stamps saved by the Foxit SDK from previous initialization cycles
        this.clearCacheForJetfileStamps();

        this.securityService.initToken();
        return Promise.resolve(true);
    }

    private clearCacheForJetfileStamps() {
        const request = indexedDB.open("FoxitWebPDFSDKForWeb");

        request.onupgradeneeded = function (event) {
            (event.target as IDBOpenDBRequest).transaction?.abort();
        };  

        request.onsuccess = function () {
            const db = request.result;

            if (!db.objectStoreNames.contains("data")) {
                db.close();
                //let internal foxit logic recreate corrupted database
                indexedDB.deleteDatabase("FoxitWebPDFSDKForWeb");
                return;
            } 

            const transaction = db.transaction("data", "readwrite");
            const store = transaction.objectStore("data");

            const getAllRequest = store.getAll();

            getAllRequest.onsuccess = function () {
                const allItems = getAllRequest.result;
                const getKeysRequest = store.getAllKeys();

                getKeysRequest.onsuccess = function () {
                    const keys = getKeysRequest.result;

                    allItems.forEach((entry, index) => {
                    let modified = false;

                    for (const [category, items] of Object.entries(entry)) {
                        if (Array.isArray(items)) {
                        const filtered = items.filter((item: any) => !item.stampId);
                        if (filtered.length !== items.length) {
                            (entry as any)[category] = filtered;
                            modified = true;
                        }
                        }
                    }

                    if (modified) {
                        const key = keys[index];
                        const putRequest = store.put(entry, key);
                        putRequest.onerror = () => console.error("Failed to update entry for key", key);
                        }
                    });
                };
            };

            transaction.oncomplete = () => {
                console.log("Foxit IndexedDB cleanup completed.");
                db.close();
            };
        };
    }
}
